import { Component } from 'shimmer'

import { Loader } from '@/utils/Loader'
import { webGL } from '@/webGL/WebGL'
import { Water } from '@/webGL/objects/Water'
import { Reflector } from '@/webGL/objects/Reflector'

import { Train } from '@/webGL/objects/Train'
import { Drone } from '@/webGL/objects/Drone'
import trainPositionsInt from '@/assets/data/trainPositionsInt.json'
import trainPositionsExt from '@/assets/data/trainPositionsExt.json'

import { emitter } from '@/utils/emitter'

export class Town extends Component {
  constructor (url, urlTrain, urlDrone) {
    super('Town')

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.promises = []
    this.reflectors = []

    this.promises.push(this.addItem(url))

    this.scale.set(200, 200, 200)

    this.trainInt = new Train(trainPositionsInt, urlTrain)
    this.trainExt = new Train(trainPositionsExt, urlTrain, true)
    this.drones = []

    for( let i = 0; i < 3 ; i++) {
      this.drones.push(new Drone(urlDrone, Math.random() * i))
    }

    this.promises.push(this.trainInt.promise)
    this.promises.push(this.trainExt.promise)
    this.promises.push(this.drones.map(drone => drone.promise))

    this.add(this.trainInt)
    this.add(this.trainExt)
    this.add(...this.drones)

    Promise.all(this.promises).then(this.resolve)

    emitter.on('mainScene:pause', () => {
      this.trainInt.isActive = false
      this.trainExt.isActive = false
      this.drones.forEach(drone => drone.isActive = false)
    })
    emitter.on('mainScene:start', () => {
      this.trainInt.isActive = true
      this.trainExt.isActive = true
      this.drones.forEach(drone => drone.isActive = true)
    })

  }

  async addItem (url) {
    this.item = await Loader.load(url, true, this.setupItem)

    this.add(this.item)
  }

  setupItem (obj) {
    // obj.material = new MeshStandardMaterial({
    //   color: 0xe1e1e1,
    //   emissive: 0x000000,
    //   roughness: .5,
    //   metalness: 1
    // })
  }
}